<template>
    <div class="result-filter facet-filter file-categories">
        <h5 class="filter-title facet-type">
            <div class="btn toggle-xs" data-toggle="collapse-next">
              {{$t("service_download.filter_sorting.facet_filter_"+this.config.facetName)}}<i
                    class="icon icon-toggle-state"></i>
            </div>
        </h5>
        <ul class="collapse">
            <li v-bind:key="option.id" v-for="(option,index) in options">
                <div :class="{'selected':option.selected}" class="checkbox badge-styled badge">
                    <input :id="'facet-type-'+option.id" :value="true" @change="updateSelection($event,option)"
                           type="checkbox"
                           v-model="option.selected">
                    <label :for="'facet-type-'+option.id">{{option.name}} <span
                            class="result count">({{option.count}})</span></label>
                </div>
            </li>

        </ul>
        <button @click="resetSelection()" class="btn btn-action action-remove-filter" v-show="showRemoveAction">
            {{$t("service_download.filter_sorting.filter_remove")}}
        </button>
    </div>
</template>

<script>
    import mixin from '../FacetMixin';

    export default {
        name: "FilterCategoryLabelCloud",
        props: ['facet', 'value', 'facetId','config'],
        mixins: [mixin],
        data: function () {
            return {
                update: true,
                selection: [],
            }
        },
        methods: {
            selected(item) {
                return this.selection.indexOf(item) >= 0;
            },
            getOptionName(id) {
                let filter = this.$options.filters.category;
                let name = filter(id);
                return name;
            },
        }
    }
</script>

<style lang="less" scoped>
    .facet-filter {
        .list-unstyled {

        }

        .badge-styled {
            position: relative;

            label {
                min-height: inherit;
                padding-left: inherit;
            }

            input {
                opacity: 0;
                width: 0;
                height: 0;
                position: absolute;
                z-index: -1;
            }
        }
    }

</style>
